import { BaseDosageChoice, DosageSequence } from "@/service/models/common/query-dosage/dosage-choices";
import { BaseDosageChoiceVM } from "./base-dosage-choice-vm";

export class DosageSequenceVM extends BaseDosageChoiceVM
{
    public dosages: BaseDosageChoiceVM[] = [];

    /**
     * @inheritdoc
     */
    public isValid(): boolean
    {
        if (this.dosages.length === 0) {
            return false;
        }

        for (const dosage of this.dosages) {
            if (!dosage.isValid()) {
                return false;
            }
        }

        return true;
    }

    /**
     * @inheritdoc
     */
    public getModel(): DosageSequence
    {
        const dosages: BaseDosageChoice[] = [];
        
        for (const dosage of this.dosages) {
            dosages.push(dosage.getModel());
        }

        return new DosageSequence(dosages);
    }

    /**
     * @inheritdoc
     */
    public fillFromModel(model: DosageSequence): DosageSequenceVM
    {
        this.dosages.splice(0);

        for (const dosage of model.dosages) {
            this.dosages.push(dosage.makeViewModel());
        }

        return this;
    }
}
